import { render, staticRenderFns } from "./OnboardingStepCampaigns.vue?vue&type=template&id=24c03c0a&scoped=true&"
import script from "./OnboardingStepCampaigns.vue?vue&type=script&lang=js&"
export * from "./OnboardingStepCampaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c03c0a",
  null
  
)

export default component.exports